// extracted by mini-css-extract-plugin
export default {"worldIndexChart":"style_worldIndexChart__-H+yu","chartWrapper":"style_chartWrapper__3xbaC","indexChartTitle":"style_indexChartTitle__KOdfp"};